import React from "react";
import ReactMarkdown from "react-markdown";

interface DescriptionProps{
    description?: string;
    buttonHref?: string;
    buttonText?: string;
}

export const DescriptionBLock = ({ description, buttonHref, buttonText }: DescriptionProps) =>
    <div className="st-snippet-description_block">
        {
            description ?
            <ReactMarkdown className="st-snippet-description_content" source={description}></ReactMarkdown> :
            null
        }
        {buttonHref || buttonText ? <a
            className="st-snippet-description_button" href={buttonHref || ""}
            target="_blank"
        >{buttonText || ""}</a> : null}
    </div>;
